export default __webpack_public_path__ + "static/media/transactionBroadcast.ac02d3df.svg";